import { ReactNode } from 'react';
import { Button } from '../Button/Button';

import ArrowLeftIcon from '../../../assets/arrow-left.svg?react';

type BackButtonProps = {
  onClick: () => void;
  children: ReactNode;
  className?: string;
};
export const BackButton = ({ onClick, children, className }: BackButtonProps) => (
  <Button
    className={`!bg-transparent inline-flex items-center gap-2 !p-0 text-lg !text-neutral-700 hover:!text-neutral-200 3xl:absolute 3xl:left-[78px] ${className}`}
    onClick={onClick}
  >
    <ArrowLeftIcon />
    {children}
  </Button>
);
